import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { getPopupIdByTemplateId, LAYER } from 'js/components/common/PopupManager';

// todo handle different types of messages according to API ShowMessageNotification (31026)
export const handleShowMessageNotification = ({ message, closeClient, templateId, className, title }) => {
    const defaultPushPopupTitle = 'playtech.mobile.system.message.congratulations';
    return showCommonPopupAction({
        content: message,
        ...className && { className },
        id: getPopupIdByTemplateId(templateId),
        title: title || defaultPushPopupTitle,
        ...closeClient && { layer: LAYER.LOGOUT_MESSAGES }
    });
};
